import { render, staticRenderFns } from "./Uploads.vue?vue&type=template&id=aaf33dd2&scoped=true"
import script from "./Uploads.vue?vue&type=script&lang=js"
export * from "./Uploads.vue?vue&type=script&lang=js"
import style0 from "./Uploads.vue?vue&type=style&index=0&id=aaf33dd2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaf33dd2",
  null
  
)

export default component.exports